import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { 
  Router, 
  RedirectCommand,
  ResolveFn,
  UrlTree
} from '@angular/router';
import { UserService } from '../services/user_service';
import { User } from '../types/user';

type UserResolveResult = User | null | RedirectCommand;

export const userResolver: ResolveFn<UserResolveResult> = () => {
  const platformId = inject(PLATFORM_ID);
  const userService = inject(UserService);
  const router = inject(Router);

  if (isPlatformServer(platformId)) {
    console.log('UserResolve: SSR mode detected, skipping profile check.');
    return Promise.resolve(null);
  }
  
  const rootUrl: UrlTree = router.parseUrl('/');

  return userService.getProfile(true).then((user: User) => {
      if (user) {
          console.log('UserResolve: User authenticated.');
          return user;
      } else {
          console.log('UserResolve: User not authenticated, redirecting to root.');
          return new RedirectCommand(rootUrl);
      }
    })
    .catch(err => {
      console.error('UserResolve: API error during getProfile. Redirecting.', err);
      return new RedirectCommand(rootUrl); 
    });
};